<template>
    <div style="text-align:center">
        
         <PincodeInput
            v-model="code"
            placeholder="0"
            />
        <div style="margin:10px">
        <s-button icon="check" theme="is-success" label="valider" @onclick="$emit('verify', code)" id="code"/>
        </div>
    </div>
</template>
<style scoped>
    .divInput {
        display: inline-block;
    }
    input {
        -moz-appearance: textfield;
        margin-left: 30px;
        width: 60px;
    }
     input::-webkit-outer-spin-button,
     input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }
</style>
<script>
export default {
    
    data() {
        return {
            code: "0000"
        }
    },
   
}
</script>